import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  noMatchingRecords: {
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(6),
    fontStyle: 'italic'
  }
}));
const CollectorEmptyPageMessage: React.FC = () => {
  const classes = useStyles();
  return (
    <Typography
      variant="body2"
      className={classes.noMatchingRecords}
      data-testid="noMatchingCollector"
    >
      <FormattedMessage id={'collectorError.noMatchingCollector'} />
    </Typography>
  );
};

export default CollectorEmptyPageMessage;
